import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InstalmentTaxPage = lazy(() => import("@/features/dashboard/pages/instalment-tax"));

export const Route = createFileRoute("/(app)/dashboard/instalment-tax")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <InstalmentTaxPage />
    </Suspense>
  ),
});
